import header from './header';
import categoryTiles from './category-tiles';
import contents from './contents';
import next from './next';
import footer from './footer';
import members from './members';
import parseBody from './parseBody';
import homepageMid from './homepage-mid';
import individualDrugClasses from './individual-drug-classes';
import injectReferenceLink from './inject-reference-link';

const items = [
    {
        name: 'Our People',
        link: '/about/members.html',
        newTab: false,
    },
    {
        name: 'Funding',
        link: '/about/funding.html',
        newTab: false,
    },
    {
        name: 'Other Publications',
        link: '/about/other-publications.html',
        newTab: false,
    },
    {
        name: 'Other Helpful Links',
        link: '/about/other-helpful-links.html',
        newTab: false,
    },
    // {
    //     name: 'Public Consultation Materials',
    //     link: '/about/documents-for-public-consultation.html#public-consultation-materials',
    //     newTab: false,
    // },
    // {
    //     name: 'DRAFT Deprescribing Guidelines',
    //     link: 'https://dl.dropboxusercontent.com/scl/fi/doxx4jofk2bi64xov9mv1/Guideline-draft-public-consultation.pdf?rlkey=0t65l4p17bwk682b4tkrai18h&st=qwekj8kd',
    //     newTab: true,
    // },
    // {
    //     name: 'DRAFT Technical Report',
    //     link: 'https://dl.dropboxusercontent.com/scl/fi/e8p9hn9y0399qmfplfsjh/Technical-report-public-consultation.pdf?rlkey=luva2fjosleyqno7p58p5h55o&st=ojv35d9q',
    //     newTab: true,
    // },
    // {
    //     name: 'DRAFT Administrative Report',
    //     link: 'https://dl.dropboxusercontent.com/scl/fi/mhzngu4a3s4slallmt48o/Administrative-report-public-consultation.pdf?rlkey=8kervnf5ui76j2whw2wh8gbx1&st=7vizohz4',
    //     newTab: true,
    // },
    // {
    //     name: 'DRAFT Dissemination Plan',
    //     link: 'https://dl.dropboxusercontent.com/scl/fi/ht05sap4434br18d4pnb4/Dissemination-and-implementation-plan-public-consultation.pdf?rlkey=3vlymyhuzm206h8el2wcg4rbr&st=oumje1eb',
    //     newTab: true,
    // },
];

header();
categoryTiles();
contents();
next();
footer(items);
members();
parseBody();
homepageMid();
individualDrugClasses();
injectReferenceLink();
